import React from "react";
import Agent from "./Agent";
import Hero from "./Hero";

import { Container } from "./style";

const Property = () => {
  return (
    <Container>
      <Hero />
      <Agent />
    </Container>
  );
};

export default Property;
